// ── Tier 1 UX patches: DEV MODE banner, Demo/Live pill, Welcome Tour ──

// ── Alpha banner ─────────────────────────────────────────────────────
function DevModeBanner() {
  const [dismissed, setDismissed] = React.useState(false);
  React.useEffect(() => {
    if (sessionStorage.getItem("gq_alpha_dismissed") === "1") setDismissed(true);
  }, []);
  if (dismissed) return null;
  return (
    <div style={{
      background: "linear-gradient(90deg, rgba(217,70,239,0.10), rgba(217,70,239,0.18))",
      color: "var(--ink)", padding: "6px 16px",
      fontFamily: "var(--font-ui)", fontSize: 12, fontWeight: 500,
      textAlign: "center", letterSpacing: "0.02em",
      display: "flex", alignItems: "center", justifyContent: "center", gap: 12,
      position: "sticky", top: 0, zIndex: 200,
      borderBottom: "1px solid rgba(217,70,239,0.25)",
    }}>
      <span><b style={{color:"#D946EF"}}>Private alpha</b> · paper trading only · no warranties · feedback welcome</span>
      <button onClick={()=>{ sessionStorage.setItem("gq_alpha_dismissed","1"); setDismissed(true); }} style={{
        background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.10)", color: "var(--muted)",
        borderRadius: 9999, padding: "2px 10px", fontSize: 10, cursor: "pointer",
      }}>Dismiss</button>
    </div>
  );
}

// ── Demo/Live data pill ──────────────────────────────────────────────
function DataModePill({ live = false }) {
  return (
    <div style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: "3px 10px", borderRadius: "var(--r-full)",
      background: live ? "rgba(17,255,153,0.10)" : "rgba(59,158,255,0.10)",
      border: `1px solid ${live ? "rgba(17,255,153,0.25)" : "rgba(59,158,255,0.25)"}`,
    }}>
      <div style={{
        width: 6, height: 6, borderRadius: "50%",
        background: live ? "#11ff99" : "#3b9eff",
        boxShadow: `0 0 6px ${live ? "rgba(17,255,153,0.6)" : "rgba(59,158,255,0.5)"}`,
      }}/>
      <span style={{
        fontFamily: "var(--font-mono)", fontSize: 10,
        color: live ? "#11ff99" : "#3b9eff",
        letterSpacing: "0.06em", textTransform: "uppercase", fontWeight: 600,
      }}>{live ? "Live data" : "Demo"}</span>
    </div>
  );
}

// ── Welcome Tour (5-step overlay) ────────────────────────────────────
const TOUR_STEPS = [
  { title: "Welcome to the alpha.",        body: "A 30-second tour. Everything here is paper-trading only — strategies, runs, marketplace listings are real but no capital is at risk.",                                                action: "Start" },
  { title: "Your vault.",                  body: "All your strategies live here. Each row shows the latest backtest's Sharpe, drawdown, and a sparkline from the real equity curve.",                                                   action: "Next" },
  { title: "Mint → Lab → Backtest.",       body: "Mint a strategy from a template, refine it in the Lab, then run a real backtest. Backtests support walk-forward CV and multi-asset baskets.",                                          action: "Next" },
  { title: "Optimize + stress.",           body: "Tune parameters with a genetic algorithm or Bayesian search — both surface a PBO score so you know when you're overfitting. Stress-test against historical crises + Monte Carlo paths.",  action: "Next" },
  { title: "Ask GQ.",                      body: "Bottom-right corner. The AI knows your pipeline state and can run backtests, optimizations, and stress tests on your behalf — with your approval before each action.",                action: "Get started" },
];

function WelcomeTour({ onClose }) {
  const [step, setStep] = React.useState(0);

  const dismiss = () => {
    localStorage.setItem("gq_tour_completed", "1");
    onClose();
  };

  const next = () => {
    if (step < TOUR_STEPS.length - 1) setStep(step + 1);
    else dismiss();
  };

  const s = TOUR_STEPS[step];
  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
      backdropFilter: "blur(8px)", zIndex: 6000,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
    }}>
      <div style={{
        maxWidth: 500, width: "100%",
        background: "var(--bg-card)", border: "1px solid var(--border-strong)",
        borderRadius: "var(--r-lg)", padding: 32,
        position: "relative",
      }}>
        {/* Step indicator */}
        <div style={{ display: "flex", gap: 4, marginBottom: 20 }}>
          {TOUR_STEPS.map((_, i) => (
            <div key={i} style={{
              flex: 1, height: 3, borderRadius: 9999,
              background: i <= step ? "#11ff99" : "rgba(255,255,255,0.08)",
              transition: "background .3s",
            }}/>
          ))}
        </div>

        <button onClick={dismiss} style={{
          position: "absolute", top: 18, right: 18,
          background: "none", border: "none", color: "var(--muted)",
          cursor: "pointer", fontSize: 18, padding: 4,
        }}>✕</button>

        <div style={{
          fontFamily: "var(--font-ui)", fontSize: 11, fontWeight: 600,
          color: "var(--cta)", letterSpacing: "0.08em", textTransform: "uppercase",
          marginBottom: 10,
        }}>Step {step + 1} of {TOUR_STEPS.length}</div>

        <h2 style={{
          fontFamily: "'Inter Tight','Inter',sans-serif", fontSize: 28,
          color: "var(--ink)", fontWeight: 700, letterSpacing: "-0.025em",
          marginBottom: 12, lineHeight: 1.15,
        }}>{s.title}</h2>

        <p style={{
          fontFamily: "var(--font-ui)", fontSize: 15, color: "var(--body)",
          lineHeight: 1.6, marginBottom: 28,
        }}>{s.body}</p>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <button onClick={dismiss} style={{
            background: "none", border: "none", color: "var(--muted)", cursor: "pointer",
            fontFamily: "var(--font-ui)", fontSize: 12, fontWeight: 500,
            textDecoration: "underline", textDecorationColor: "rgba(255,255,255,0.2)",
          }}>Skip tour</button>
          <button onClick={next} className="btn btn-primary btn-sm">
            {s.action} →
          </button>
        </div>
      </div>
    </div>
  );
}

// ── ⌘K Command Palette ───────────────────────────────────────────────
function CommandPalette({ open, onClose, onNavigate, onAskGQ }) {
  const [query, setQuery] = React.useState("");
  const [selectedIdx, setSelectedIdx] = React.useState(0);

  const commands = [
    { id:"vault",       label:"Go to vault",            icon:Wallet,     action: () => onNavigate("vault") },
    { id:"designer",    label:"Go to strategy lab",      icon:Layers,     action: () => onNavigate("designer") },
    { id:"optimize",    label:"Go to GQ™ Optimize",     icon:Cpu,        action: () => onNavigate("optimize") },
    { id:"stress",      label:"Go to stress test",        icon:Shield,     action: () => onNavigate("stress") },
    { id:"marketplace", label:"Go to marketplace",        icon:Store,      action: () => onNavigate("marketplace") },
    { id:"tearsheet",   label:"Open performance tearsheet", icon:FileText, action: () => onNavigate("tearsheet") },
    { id:"settings",    label:"Open settings",            icon:Settings,   action: () => onNavigate("settings") },
    { id:"exchanges",   label:"Manage exchange connections", icon:DollarSign, action: () => onNavigate("exchanges") },
    { id:"askgq",       label:"Ask GQ™ AI a question",   icon:Sparkles,   action: () => onAskGQ() },
    { id:"new",         label:"Mint a new strategy",      icon:Plus,       action: () => onNavigate("mint") },
    { id:"compare",     label:"Compare two strategies",   icon:GitMerge,   action: () => onNavigate("compare") },
    { id:"backtest",    label:"Run a backtest",           icon:Play,       action: () => onNavigate("backtest") },
    { id:"share",       label:"Open the public share view (demo)", icon:Share, action: () => window.open("../share.html", "_blank") },
    { id:"help",        label:"Show keyboard shortcuts",  icon:HelpCircle, action: () => onNavigate("__help") },
  ];

  const filtered = query.trim() === "" ? commands : commands.filter(c => c.label.toLowerCase().includes(query.toLowerCase()));

  React.useEffect(() => { setSelectedIdx(0); }, [query]);

  React.useEffect(() => {
    if (!open) { setQuery(""); setSelectedIdx(0); }
  }, [open]);

  const handleKey = (e) => {
    if (e.key === "Escape") onClose();
    else if (e.key === "ArrowDown") { e.preventDefault(); setSelectedIdx(i => Math.min(i+1, filtered.length-1)); }
    else if (e.key === "ArrowUp")   { e.preventDefault(); setSelectedIdx(i => Math.max(i-1, 0)); }
    else if (e.key === "Enter")     { e.preventDefault(); if (filtered[selectedIdx]) { filtered[selectedIdx].action(); onClose(); } }
  };

  if (!open) return null;
  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)",
      backdropFilter: "blur(6px)", zIndex: 7000,
      display: "flex", alignItems: "flex-start", justifyContent: "center",
      paddingTop: "12vh",
    }}>
      <div onClick={e=>e.stopPropagation()} style={{
        width: "100%", maxWidth: 560,
        background: "var(--bg-card)", border: "1px solid var(--border-strong)",
        borderRadius: "var(--r-lg)", overflow: "hidden",
      }}>
        <div style={{ padding: 16, borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--muted)", letterSpacing: "0.05em" }}>⌘K</span>
          <input
            autoFocus
            value={query}
            onChange={e=>setQuery(e.target.value)}
            onKeyDown={handleKey}
            placeholder="Search commands, jump anywhere…"
            style={{
              flex: 1, background: "transparent", border: "none",
              fontFamily: "var(--font-ui)", fontSize: 15, color: "var(--ink)",
              outline: "none",
            }}
          />
          <span style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--subtle)" }}>ESC</span>
        </div>
        <div style={{ maxHeight: "55vh", overflowY: "auto", padding: 8 }}>
          {filtered.length === 0 ? (
            <div style={{ padding: 24, textAlign: "center", fontFamily: "var(--font-ui)", fontSize: 13, color: "var(--subtle)" }}>No matches</div>
          ) : filtered.map((c, i) => {
            const Ic = c.icon;
            return (
              <button key={c.id} onClick={() => { c.action(); onClose(); }}
                onMouseEnter={()=>setSelectedIdx(i)}
                style={{
                  width: "100%", display: "flex", alignItems: "center", gap: 12,
                  background: i === selectedIdx ? "rgba(255,255,255,0.05)" : "transparent",
                  border: "none", padding: "10px 12px", borderRadius: "var(--r-md)",
                  cursor: "pointer", textAlign: "left",
                  fontFamily: "var(--font-ui)", fontSize: 13, color: "var(--ink)",
                }}>
                <span style={{ width: 22, display: "flex", alignItems: "center", justifyContent: "center", color: c.id === "askgq" ? "#D946EF" : "var(--muted)" }}>
                  <Ic size={14}/>
                </span>
                <span>{c.label}</span>
                {i === selectedIdx && <span style={{ marginLeft: "auto", fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--subtle)" }}>↵</span>}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ── Keyboard shortcuts modal ─────────────────────────────────────────
function ShortcutsModal({ open, onClose }) {
  if (!open) return null;
  const SHORTCUTS = [
    { keys: ["⌘", "K"],            label: "Open command palette" },
    { keys: ["?"],                 label: "Show this help" },
    { keys: ["G", "V"],            label: "Go to Vault" },
    { keys: ["G", "L"],            label: "Go to Strategy Lab" },
    { keys: ["G", "O"],            label: "Go to Optimize" },
    { keys: ["G", "S"],            label: "Go to Stress Test" },
    { keys: ["G", "M"],            label: "Go to Marketplace" },
    { keys: ["A"],                 label: "Open Ask GQ™ AI" },
    { keys: ["Esc"],               label: "Close any modal" },
    { keys: ["/"],                 label: "Focus search input" },
  ];
  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)",
      backdropFilter: "blur(8px)", zIndex: 6500,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
    }}>
      <div onClick={e=>e.stopPropagation()} style={{
        maxWidth: 460, width: "100%",
        background: "var(--bg-card)", border: "1px solid var(--border-strong)",
        borderRadius: "var(--r-lg)", padding: 28,
      }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
          <h3 style={{ fontFamily: "'Inter Tight','Inter',sans-serif", fontSize: 22, fontWeight: 700, color: "var(--ink)", letterSpacing: "-0.02em" }}>Keyboard shortcuts</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "var(--muted)", cursor: "pointer", fontSize: 18, padding: 4 }}>✕</button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {SHORTCUTS.map((s, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 0", borderBottom: i < SHORTCUTS.length-1 ? "1px solid var(--border)" : "none" }}>
              <span style={{ fontFamily: "var(--font-ui)", fontSize: 13, color: "var(--body)" }}>{s.label}</span>
              <div style={{ display: "flex", gap: 4 }}>
                {s.keys.map((k, j) => (
                  <kbd key={j} style={{
                    fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--ink)",
                    background: "rgba(255,255,255,0.04)", border: "1px solid var(--border-strong)",
                    borderRadius: 4, padding: "2px 8px", minWidth: 20, textAlign: "center", fontWeight: 600,
                  }}>{k}</kbd>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ── EU cookie consent banner ─────────────────────────────────────────
function CookieBanner() {
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => {
    if (!localStorage.getItem('gq_cookie_consent')) setVisible(true);
  }, []);
  if (!visible) return null;
  const accept = () => {
    localStorage.setItem('gq_cookie_consent', 'accepted');
    window.GQ?.observability?.posthog?.opt_in_capturing?.();
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem('gq_cookie_consent', 'rejected');
    window.GQ?.observability?.posthog?.opt_out_capturing?.();
    setVisible(false);
  };
  return (
    <div style={{
      position:'fixed', bottom:16, left:16, zIndex:9999, maxWidth:340,
      background:'rgba(10,10,10,0.95)', backdropFilter:'blur(12px)',
      border:'1px solid rgba(255,255,255,0.08)', borderRadius:10,
      padding:'12px 14px', fontFamily:'var(--font-ui)', fontSize:12,
      boxShadow:'0 8px 32px rgba(0,0,0,0.5)',
    }}>
      <p style={{color:'rgba(245,245,247,0.75)', lineHeight:1.5, marginBottom:10}}>
        We use analytics cookies to improve the platform. No ads, no third-party sharing.{' '}
        <a href="../privacy.html" target="_blank" style={{color:'#3b9eff', textDecoration:'none'}}>Privacy policy</a>
      </p>
      <div style={{display:'flex', gap:8}}>
        <button onClick={accept} style={{
          flex:1, padding:'5px 0', borderRadius:6, cursor:'pointer', fontSize:11, fontWeight:600,
          background:'rgba(217,70,239,0.15)', border:'1px solid rgba(217,70,239,0.3)', color:'#D946EF',
        }}>Accept</button>
        <button onClick={reject} style={{
          flex:1, padding:'5px 0', borderRadius:6, cursor:'pointer', fontSize:11,
          background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', color:'rgba(245,245,247,0.5)',
        }}>Reject</button>
      </div>
    </div>
  );
}

// ── Mobile "best on desktop" banner ──────────────────────────────────
function MobileBanner() {
  const [dismissed, setDismissed] = React.useState(false);
  const [narrow, setNarrow] = React.useState(() =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia("(max-width: 900px)").matches
      : false
  );
  React.useEffect(() => {
    if (localStorage.getItem("gq_mobile_banner_dismissed") === "1") setDismissed(true);
    const mq = window.matchMedia("(max-width: 900px)");
    const onChange = (e) => setNarrow(e.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);
  if (dismissed || !narrow) return null;
  return (
    <div style={{
      background: "linear-gradient(90deg, rgba(59,158,255,0.12), rgba(59,158,255,0.20))",
      color: "var(--ink)", padding: "8px 14px",
      fontFamily: "var(--font-ui)", fontSize: 12,
      textAlign: "center", letterSpacing: "0.01em",
      display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
      position: "sticky", top: 0, zIndex: 199,
      borderBottom: "1px solid rgba(59,158,255,0.25)",
    }}>
      <span><b style={{color:"#3b9eff"}}>Best on desktop.</b> Charts and the strategy lab are optimised for wider screens.</span>
      <button onClick={()=>{ localStorage.setItem("gq_mobile_banner_dismissed","1"); setDismissed(true); }} style={{
        background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.10)", color: "var(--muted)",
        borderRadius: 9999, padding: "2px 10px", fontSize: 10, cursor: "pointer", flexShrink: 0,
      }}>Got it</button>
    </div>
  );
}

window.DevModeBanner    = DevModeBanner;
window.MobileBanner     = MobileBanner;
window.DataModePill     = DataModePill;
window.WelcomeTour      = WelcomeTour;
window.CommandPalette   = CommandPalette;
window.ShortcutsModal   = ShortcutsModal;
window.CookieBanner     = CookieBanner;
